module.exports = __webpack_public_path__ + "img/3.2f0a01b3.png";